import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'frodo-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {
  @Input() spinnerType = 'big';
  @Input() colorSpinner: string;
  @Input() diameter = 264;
  isBigClass = true;
  @Input() src: string;
  @Input() strokeWidth = 18;

  ngOnInit(): void {
    if (this.spinnerType !== 'big') {
      this.isBigClass = false;
    }
  }
}
